module.exports = __webpack_public_path__ + "img/logo.65106d5b.png";